var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"CNCEpidemicPrevention"}},[_vm._v("数控防疫追溯分析")])
}
var staticRenderFns = []

export { render, staticRenderFns }